import DOMPurify from 'dompurify';
import { postCompanyBoomiService, postSegmentService } from '../../services/trackingServices';
import { gtagEnvelope } from '../gtagEnvelope';
import { CompanyFormData, SitecoreTrialContentType } from '../../types';
import { postTrialFormDataService } from '../../services/sitecoreServices';
import { getFlowType } from '../getFlowType';
import { FORM_TYPES } from '../../consts';
import { getEventName, getEventReason } from '../getExperimentVersion';
import { useAppStore } from '~/common/store/appStore';

interface CompanySubmission {
  data: SitecoreTrialContentType;
}

export const handleCompanyTrialSubmission = async ({ data }: CompanySubmission) => {
  const { formType, trialLength, segExpQuery, segExpValue } = useAppStore.getState();
  const flowType = getFlowType(formType);

  try {
    gtagEnvelope('event', 'cta_submit_click', {
      cta_name: `Start My Free ${trialLength}-Day Trial`,
      cta_url: `${window.location.origin}${window.location.pathname}${data.successUrl}`,
      cta_position: 'Trial Form',
    });
    await postSegmentService({
      event: `${getEventName(true)}_trial_form_click`,
      properties: {
        reason: getEventReason(),
      },
    });

    const formData: CompanyFormData = {
      trialSku: data.sku,
      clientIp: DOMPurify.sanitize(window.akCIp),
      flowType,
      formType,
      segExpQuery,
      segExpValue,
    };

    const resp = await postTrialFormDataService(formData);
    if (!resp.success) {
      return { success: false, code: resp.code };
    } else {
      gtagEnvelope('event', `trial_success_${getEventName()}`, {});
      if (flowType !== FORM_TYPES.PURCHASE) {
        formData.programName = data.inputs?.programName?.defaultValue;
        formData.programID = data.inputs?.programID?.defaultValue;
        await postCompanyBoomiService({
          data: formData,
          userKey: resp.successToken,
        });

        window.location.href = data.successLoggedInUrl;
      } else {
        window.location.href = data.successUrl;
      }
    }
  } catch (error: any) {
    return {
      success: false,
      code: '500',
      errorMessage: `Company submit error: ${error.message}`,
    };
  }
};
